<div class="flex-class">

    <div class="child-block">
        <mat-card style="margin-right: 10px; height: 100%;">
            <span class="mission-heading" >Mission Count</span>
            <!-- <div class="content-center bottom-space top-space">

                <div class="circle-blue  top-circle">
                    {{countAPIData?.sessionCount}}
                </div>
                <span class="text-class" style="margin-top: 5px;"> Session Count </span>
            </div>
            <div class="content-center1 bottom-space">
                <div class="aligning-box">
                    <div class="circle-green circle-data-green bottom-circle">
                        {{countAPIData?.clearedCount}}
                    </div>
                    <span class="text-class"> Cleared Count </span>
                </div>
                <div class="aligning-box">
                    <div class="circle-red circle-data-red bottom-circle1">{{countAPIData?.notClearedCount}}</div>
                    <span class="text-class"> Not Cleared Count </span>
                </div>
            </div> -->

            <!-- **************SG-7046 start *************** -->

            <div class="ele-place" fxLayout="column" fxFlex="100%" fxLayoutAlign="center center">
                <div class="flx" fxLayout="column" fxFlex="50%" fxLayoutAlign="center center" style="padding-bottom: 25px;">
            <div class="img-circle" id="parentElement" fxLayoutAlign="center center" fxLayout="column" style="text-align: center;"  [style.height.px]="getDynamicHeight()">
                {{countAPIData?.sessionCount}}
                <!-- 333333333 -->
               </div> 
               <span style="text-align: center;" class="text-class">Session Count</span>
            </div>
            
            <div fxLayout="column" fxFlex="100%">
                <div fxLayout="row" fxFlex="100%" fxLayoutAlign="space-between baseline">

                    <div class="flx" fxLayout="column" fxFlex="50%" fxLayoutAlign="center center">
                        <div class="cleared-img-circle" id="parentElement2" fxLayoutAlign="center center" fxLayout="column" style="text-align: center;" [style.height.px]="getDynamicHeight2()">
                            {{countAPIData?.clearedCount}}
                        </div>
                        <span style="text-align: center;color: #2D8656" class="text-class">Cleared Count</span>
                    </div>
                    <div class="flx" fxLayout="column" fxFlex="50%" fxLayoutAlign="center center" style="color: #C73535 !important;">
                        <div class="Rejected-img-circle" id="parentElement1" fxLayoutAlign="center center" fxLayout="column" style="text-align: center;" [style.height.px]="getDynamicHeight1()">
                            {{countAPIData?.notClearedCount}}
                        </div>
                        <span style="text-align: center;color: #BE1515;" class="text-class">Not Cleared Count</span>
                    </div>
                </div>
            </div>
        </div>

        <!--  ****************SG-7046 end ************ -->


        </mat-card>
    </div>

    <div class="child-block1">
        <mat-card style="height: 100%;" class="av-loader-host">
            <div class="av-loader-overlay" *ngIf="isTableLoading">
                <mat-spinner diameter="36"></mat-spinner>
            </div>
            <mat-card-header class="card-head">
                <div class="export-icon"> <span class="mission-heading"> {{this.missionName}} Records</span>

                    <i class="fa fa-share-square-o" aria-hidden="true"
                        style="font-size: 24px;margin-top:10px; color: #707070; cursor: pointer;"
                        (click)="exportCsvData('performance')"></i>
                </div>
            </mat-card-header>
            <div class="table-class">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" width="100%">


                    <ng-container matColumnDef="sessionDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="14%"> Session Date </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element?.sessionDate | date:'MMMM d, y'" pointer (click)="openUserDialog(element)">
                            {{element?.sessionDate | date:'MMMM d, y'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="completedAircrafts">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="19%"> Completed Aircrafts </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element?.completedAircrafts" pointer>
                            {{element?.completedAircrafts}} </td>
                    </ng-container>
                    <ng-container matColumnDef="damagedAircrafts">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="18%"> Damaged Aircrafts </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element?.damagedAircrafts" pointer>
                            {{element?.damagedAircrafts}} </td>
                    </ng-container>
                    <ng-container matColumnDef="receivedBonuses">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="18%"> Received Bonuses </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element?.receivedBonuses" pointer>
                            {{element?.receivedBonuses}} </td>
                    </ng-container>
                    <ng-container matColumnDef="voiceCommands">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="17%"> Voice Commands </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element?.voiceCommands" pointer>
                            {{element?.voiceCommands}} </td>
                    </ng-container>
                    <ng-container matColumnDef="textCommands">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="17%"> Text Commands </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element?.textCommands" pointer>
                            {{element?.textCommands}} </td>
                    </ng-container>
                    <ng-container matColumnDef="separationViolation">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="16%"> Separation Violations </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element?.separationViolation" pointer>
                            {{element?.separationViolation}} </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="16%"> Status </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element?.status" pointer>
                            {{element?.status}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>

                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" pointer></tr>
                </table>
            </div>
            <mat-paginator [pageSizeOptions]="[5,10, 25, 50]" [pageSize]="pageSize" [length]="missionRecords.length"
                (page)="onPageChange($event)"></mat-paginator>

        </mat-card>
    </div>

</div>

<div fxLayout="row" [ngClass]="['card-height']" fxLayoutAlign="space-between" fxLayoutGap="10px">
    <mat-card class="flx-card wd-mx crd-ovrflw bottom-card-ht av-loader-host">
        <div class="av-loader-overlay" *ngIf="isGraphLoading">
            <mat-spinner diameter="36"></mat-spinner>
        </div>
        <mat-card-header class="grp_hdr">
            <article [ngClass]="['header-padding']">
                <div fxLayout="column" fxLayoutAlign="start center">
                    <h4 ngClass="selectlist-label" *ngIf="dateType?.type == 'month' || dateType?.type == 'Month'">Last 24
                        Month's Data</h4>
                    <h4 ngClass="selectlist-label" *ngIf="dateType?.type == 'day' || dateType?.type == 'Day'">Last 1
                        Month's Data</h4>
                    <h4 ngClass="selectlist-label" *ngIf="dateType?.type === 'year' || dateType?.type === 'Year'">Last 5
                        Year's Data</h4>
                </div>
                <nav class="nv_rt rpd">
                    <div fxLayout="row" fxLayoutGap="10px">
                        <div fxLayout="column" fxLayoutAlign="end center">
                            <div fxLayout="row">
                                <h4 ngClass="selectlist-label"
                                    *ngIf="usageAnalyticsSelectedValue !== 'totalPlayedSession' &&
                            usageAnalyticsSelectedValue !== 'averageDuration' &&
                            usageAnalyticsSelectedValue!=='masteredPracticeSets' && usageAnalyticsSelectedValue === 'All'">
                                    Usage : </h4>
                                <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'TotalMissions'">
                                    Total Missions Sessions :
                                </h4>
                                <h4 ngClass="selectlist-label"
                                    *ngIf="usageAnalyticsSelectedValue === 'AvgMissionDuration'">Average Mission
                                    Duration :
                                </h4>
                                <h4 ngClass="selectlist-label"
                                    *ngIf="usageAnalyticsSelectedValue === 'ClearedMissions'">Total Cleared Missions :
                                </h4>

                                <h4 ngClass="selectlist-label"
                                    *ngIf="usageAnalyticsSelectedValue === 'NotClearedMissions'">Total Not Cleared
                                    Missions :
                                </h4>
                                <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'VoiceCommands'">
                                    Total Voice Commands :
                                </h4>
                                <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'TextCommands'">
                                    Total Text Commands :
                                </h4>
                                <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'separationViolation'">
                                    Total Separation Violations :
                                </h4>
                                <mat-form-field class="mrgn drpdown-chart-options duration-dropdown form-field"
                                    appearance="outline">
                                    <mat-select [(ngModel)]="usageAnalyticsSelectedValue" name="usageEramAnalytics"
                                        (selectionChange)="changeAnalytics($event.value)">
                                        <mat-option class="drp-options" *ngFor="let ua of usageEramAnalytics"
                                            [value]="ua.value">
                                            {{ua.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div fxLayout="column">
                            <i class="fa fa-share-square-o" aria-hidden="true"
                                style="font-size: 24px;margin-top:10px; color: #707070; cursor: pointer;"
                                (click)="exportCsvData('usage')"></i>
                        </div>
                    </div>
                </nav>
            </article>
        </mat-card-header>
        <mat-card-content class="flx_tm">
            <!-- <mat-spinner *ngIf="!sessionPlayedChartDatasets" diameter="20" ngClass="loader"></mat-spinner> -->
            <app-highcharts [totalLessionsSessions]="totalLessionsSessions" [updateChart]="updateChart">
            </app-highcharts>
        </mat-card-content>
    </mat-card>
</div>